import { css } from '@emotion/react';
import { margins } from '@spotnana/blocks/src/utils';

export const strike_through = css`
  text-decoration: line-through;
`;

export const flight_marketing_label = css`
  display: flex;
  gap: 0.5rem;
`;

export const hidden_layover_item = css`
  ${margins.yt.m1}
`;
